import styled from 'styled-components';

import { elemMixin } from '../form/mixins.styles';

export const InputControl = styled.input<{ errored?: boolean; textRight?: boolean; innerInputStartAdornment?: JSX.Element; innerInputEndAdornment?: JSX.Element; }>`
  ${({ errored, textRight, innerInputStartAdornment, innerInputEndAdornment }) => elemMixin(errored, textRight, innerInputStartAdornment, innerInputEndAdornment)}
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StartAdornmentWrapper = styled.div`
  margin-right: .5rem;
`;

